import type { CSSProperties, ImgHTMLAttributes } from 'react'

type AppImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string
  alt: string
  width?: number | string
  height?: number | string
  fill?: boolean
  priority?: boolean
  unoptimized?: boolean
}

/** Drop-in for `next/image` in the Vite bundle (no image optimizer). */
export default function AppImage({
  src,
  alt,
  width,
  height,
  className,
  style,
  fill,
  priority: _priority,
  unoptimized: _unoptimized,
  ...rest
}: AppImageProps) {
  const imgStyle: CSSProperties | undefined = fill
    ? {
        ...style,
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover'
      }
    : style

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={imgStyle}
      loading="lazy"
      decoding="async"
      {...rest}
    />
  )
}
